import { render, staticRenderFns } from "./chateau-figeac.vue?vue&type=template&id=3df660c6&scoped=true"
import script from "./chateau-figeac.vue?vue&type=script&lang=js"
export * from "./chateau-figeac.vue?vue&type=script&lang=js"
import style0 from "./chateau-figeac.vue?vue&type=style&index=0&id=3df660c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df660c6",
  null
  
)

export default component.exports